// Module
var code = "<mm-card caption=\"$ctrl.caption\" sub-caption=\"$ctrl.subCaption\" icon=\"'user'\" response=\"$ctrl.response\" url=\"'#!/sites/' + $ctrl.siteId + '/users'\"></mm-card> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Site/Overview/Persons/Persons.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;